import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutDirectorsAndManagementHeroContentSectionHeaderCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About Directors And Management Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutDirectorsAndManagementHeroContentSectionHeaderCls || '',
			'about_directors_and_management_hero', { animCls: 'animate__fadeInDown50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;